import { logo } from './logo_elsalto'
import { tableProps } from './tabla'

const state = {
   // httpURL: 'https://elsalto.gob.mx/portal-api/test',
   httpURL: 'https://elsalto.gob.mx/portal-api',
    //httpURL: 'http://127.0.0.1:3010',
    sessionToken: null,
    userName: 'Unknown user',
    logoHorizontal: logo,
    permisos: [],
    role: 'user',
    userId: '',
    tableProps
}

const getters = {
    httpURL: state => {
        return state.httpURL;
    },
    sessionToken: state => {
        return state.sessionToken;
    },
    userName: state => {
        return state.userName;
    },
    logoHorizontal: state => {
        return state.logoHorizontal;
    },
    permisos: state => {
        return state.permisos;
    },
    role: state => {
        return state.role;
    },
    userId: state => {
        return state.userId;
    },
    tableProps: state => {
        return state.tableProps;
    }
}

// actions
const actions = {
    setSessionToken(context, payload) {
        context.commit('setSessionTokenHandler', payload);
    },
    setUserName(context, payload) {
        context.commit('setUserNameHandler', payload);
    },
    setLogoHorizotal(context, payload) {
        context.commit('setLogoHorizotalHandler');
    },
    setPermisos(context, payload) {
        context.commit('setPermisosHandler', payload);
    },
    setRole(context, payload) {
        context.commit('setRoleHandler', payload);
    },
    setUserId(context, payload) {
        context.commit('setUserIdHandler', payload);
    }
}

// mutations
const mutations = {
    setSessionTokenHandler(state, token) {
        state.sessionToken = token;
    },
    setUserNameHandler(state, name) {
        state.userName = name;
    },
    setLogoHorizotalHandler(state, logo) {
        state.logoHorizontal = logo;
    },
    setPermisosHandler(state, permisos) {
        state.permisos = permisos;
    },
    setRoleHandler(state, role) {
        state.role = role;
    },
    setUserIdHandler(state, userId) {
        state.userId = userId;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}